import { render, staticRenderFns } from "./Page_Single_Product.vue?vue&type=template&id=0c8c5dcf&scoped=true&"
import script from "./Page_Single_Product.vue?vue&type=script&lang=js&"
export * from "./Page_Single_Product.vue?vue&type=script&lang=js&"
import style0 from "@/css/Main_style.scss?vue&type=style&index=0&id=0c8c5dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c5dcf",
  null
  
)

export default component.exports